module.exports = __webpack_public_path__ + "img/excluir.d0a3b7c6.svg";